<template>
  <div class="quick-play-layer">
    <button
      class="quick-play-backdrop"
      type="button"
      :aria-label="$t('Close Quick Play')"
      @click="$emit('close')"
    ></button>
    <section class="quick-play-sheet" role="dialog" aria-modal="true" :aria-label="$t('Quick Play')">
      <TaiXiuBoardLayout>
        <BetBoard v-bind="$attrs" compact v-on="$listeners" />
      </TaiXiuBoardLayout>
    </section>
  </div>
</template>

<script>
import BetBoard from './bet-board.vue';
import TaiXiuBoardLayout from './tai-xiu-board-layout.vue';

export default {
  inheritAttrs: false,
  components: {
    BetBoard,
    TaiXiuBoardLayout,
  },
};
</script>

<style lang="scss" scoped>
// Must stay above the cockfight sticky video (z-index 9990), which is fixed to
// the top of the viewport while quick play is open.
.quick-play-layer {
  position: fixed;
  inset: 0;
  // On the 100px footer (footer panel 66 + table bar 34).
  bottom: calc(100px + env(safe-area-inset-bottom));
  z-index: 9995;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.quick-play-backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background: rgba(3, 8, 14, 0.45);
  cursor: default;
}

.quick-play-sheet {
  position: relative;
  width: 100%;
  max-width: none;
  max-height: 100%;
  margin-bottom: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  border: 0;
  border-top: 1px solid $ga-gold-line;
  border-radius: 14px 14px 0 0;
  background: $ga-rail-bg;
  box-shadow: 0 -12px 30px rgba(0, 0, 0, 0.55);
  animation: slide-up 0.22s ease-out;
  z-index: 1;
}

@keyframes slide-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@media screen and (orientation: landscape) and (max-height: 600px) {
  .quick-play-layer {
    bottom: 0;
  }

  .quick-play-sheet {
    width: min(72%, 590px);
    max-width: 590px;
    margin-bottom: 8px;
  }
}
</style>
